module.exports = __webpack_public_path__ + "media/cancel_exit.7bf65dc1.wav";